<template>
	<div class="newsContainer">
		<div class="main">
			<p>公司新闻</p>
			<a @click="detail(item.id)" v-for="item in newsData" :key="item.id">
				<el-row class="conent-news">
					<el-col :span="2" class="time">
						<span v-if="item.updateTime">{{item.updateTime.substring(0, 4) }}</span>
						<span v-if="item.updateTime">{{item.updateTime.substring(5, 10) }}</span>
					</el-col>
					<el-col :span="21">{{ item.title }}</el-col>
					<el-col :span="1"><img src="../../../public/images/left.png" alt="" /></el-col>
				</el-row>
			</a>
			<div class="block">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[7, 14, 21, 28]"
					:page-size="100"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			currentPage: 1,
			pageSize: 7,
			total: 0,
			newsData: [],
			time: '2020-10-12'
		};
	},
	created() {
		this.getNews();
	},
	methods: {
		handleSizeChange(val) {
			this.pageSize = val;
			this.getNews();
		},
		handleCurrentChange(psize) {
			this.currentPage = psize;
			this.getNews();
		},

		getNews() {
			this.$axios
				.get(this.$Url + 'newslist/list', {
					params: {
						pageNum: this.currentPage,
						pageSize: this.pageSize
					}
				})
				.then(res => {
					this.newsData = res.data.list;
					this.total = res.data.total;
				});
		},
		detail(e) {
			this.$router.push({
				path: 'news-detail',
				query: {
					id: e
				}
			});
			// this.$router.push('/news_detail');
		}
	}
};
</script>

<style>
.newsContainer .main {
	padding: 0 16%;
}
.newsContainer .main > p {
	text-align: center;
	font-size: 26px;
	padding: 30px 0;
}
.newsContainer .main .conent-news {
	padding: 0 38px;
	display: flex;
	align-items: center;
}

.newsContainer .main > a {
	display: block;
}
.newsContainer .main > a:hover {
	background: #dceffd;
	cursor: pointer;
}
.newsContainer .main .conent-news .time > span {
	display: block;
	color: #666666;
}
.newsContainer .main .conent-news .time > span:first-of-type {
	font-size: 10px;
}
.newsContainer .main .conent-news .time > span:nth-of-type(2) {
	font-size: 24px;
}
.newsContainer .main .conent-news .el-col:nth-of-type(2) {
	font-size: 22px;
	color: #666666;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 30px 0;
	border-bottom: 1.3px solid #eee;
}
.newsContainer .main .conent-news .el-col:nth-of-type(3) {
	/* position: relative; */
}
.newsContainer .main .conent-news .el-col > img {
	/* position: absolute; */
	/* right: 21%; */
	margin-left: 68%;
	width: 20px;
	height: 36px;
}
.newsContainer .block {
	padding: 20px 0 300px 0;
}
.newsContainer .block .el-pagination {
	background: #f7faff;
	text-align: center;
}
.newsContainer .el-input__inner {
	height: 100% !important;
}
.newsContainer .btn-prev,
.newsContainer .btn-next {
	background: #f7faff;
}
.newsContainer .el-dialog,
.el-pager li {
	background: #f7faff;
}
</style>
